import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const TableCell = withStyles({
  root: {
    borderBottom: 'none',
  },
})(MuiTableCell);

const useStyles = makeStyles(theme => ({
  root: {},
  text: {
    color: theme.palette.facet.primaryGray,
  },
  textHeader: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

function TableNodeCell({
  align, isHeader, children,
}) {
  const classes = useStyles();

  return (
    <TableCell className={classes.root} align={align}>
      <Typography
        className={classNames(classes.text, {
          [classes.textHeader]: isHeader,
        })}
        variant="h6"
      >
        {children}
      </Typography>
    </TableCell>
  );
}

TableNodeCell.defaultProps = {
  align: 'left',
  isHeader: false,
};

TableNodeCell.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  isHeader: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default TableNodeCell;
